import CreateMultipleDonations from './CreateMultipleDonations'
import FakeButtons from './FakeButtons'
import classNames from 'classnames'
import styles from './Debug.module.css'
import { JSONPrettyPrint } from '@betterplace/design-system/client'
import { useDonationFormConfig, useDonationFormContext } from '@/donationPages/_dependencies/helpers'
import { useEffect, useState } from 'react'
import { useNativePaymentMethodsContext } from '@/donationPages/_dependencies/NativePaymentMethods'
import type { DonationFormValues } from '@/donationForm/types'

function FormDebug() {
  const { watch, getValues, formState } = useDonationFormContext()
  const nativePaymentContext = useNativePaymentMethodsContext()
  if (!formState.isReady) return null
  const data = {
    values: { ...watch(), ...getValues() },
    ...formState,
    ...nativePaymentContext,
  }
  return (
    <details className={classNames(styles.genericAdminBox, styles.forPlatformAdmins, styles.formDebug)}>
      <summary>Form Debug</summary>
      <JSONPrettyPrint json={data} />
    </details>
  )
}

function JSErrors() {
  const [errors, setErrors] = useState<ErrorEvent[] | []>([])

  useEffect(() => {
    const addError = (e: ErrorEvent) => setErrors([...errors, e])
    window.addEventListener('error', addError)
    return () => window.removeEventListener('error', addError)
  }, [setErrors, errors])

  return (
    <details className={classNames(styles.genericAdminBox, styles.forPlatformAdmins, styles.jsErrors)}>
      <summary>JS Errors</summary>
      <table className={classNames(styles.debugTable, styles.debugTableStriped)}>
        <tbody>
          {errors.map((e, i) => (
            <tr key={i}>
              <td>
                {/* eslint-disable-next-line @typescript-eslint/no-unsafe-member-access */}
                {e.error.name || <span>Error</span>}
                <span>:&nbsp;</span>
                {e.message}
              </td>
              <td>
                {e.filename}:{e.lineno}:{e.colno}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </details>
  )
}

function Debug({
  initialFFs,
  initialFormValues,
}: {
  initialFormValues: DonationFormValues
  initialFFs?: Record<string, string | boolean>
}) {
  const { debug } = useDonationFormConfig()
  if (!debug || process.env.NODE_ENV === 'test') return null
  // Do not check FFs this affects the population
  // const currentFFs = analytics.getFeatureFlags()

  return (
    <>
      <FakeButtons />
      <CreateMultipleDonations
        receiverType={initialFormValues.receiver_type}
        receiverId={initialFormValues.receiver_id}
      />
      <FormDebug />
      <JSErrors />
      <details className={classNames(styles.genericAdminBox, styles.forPlatformAdmins, styles.formDebug)}>
        <summary>FeatureFlags</summary>
        <JSONPrettyPrint json={initialFFs ?? {}} />
        <JSONPrettyPrint json={{}} />
      </details>
      <details className={classNames(styles.genericAdminBox, styles.forPlatformAdmins, styles.formDebug)}>
        <summary>Initial Form Values</summary>
        <JSONPrettyPrint json={initialFormValues} />
      </details>
    </>
  )
}

export default Debug
